import React from "react";
import PropTypes from "prop-types";
import { Grid } from "orcs-design-system";
import QuickLinks from "src/components/PersonDetailPage/QuickLinks";
import WorkspaceAnnouncements from "src/components/PersonDetailPage/WorkspaceAnnouncements";
import ExplorePanel from "src/pages/HomePage/sub-components/ExplorePanel";
import { AIPanel } from "./AIPanel";

const UserDashboard = ({ person, showExplorePanel = false }) => {
  return (
    <Grid
      gridGap="r"
      height="100%"
      gridTemplateColumns={[
        "repeat(auto-fit,minmax(300px,1fr))",
        "repeat(auto-fit,minmax(310px,1fr))",
        "repeat(auto-fit,minmax(420px,1fr))",
      ]}
    >
      <AIPanel />
      <QuickLinks person={person} />
      {showExplorePanel ? <ExplorePanel /> : <WorkspaceAnnouncements />}
    </Grid>
  );
};

UserDashboard.propTypes = {
  person: PropTypes.object.isRequired,
  showExplorePanel: PropTypes.bool,
};

export default UserDashboard;
